import { render } from "./controller.vue?vue&type=template&id=3713fa61"
import script from "./controller.vue?vue&type=script&lang=js"
export * from "./controller.vue?vue&type=script&lang=js"

import "./controller.vue?vue&type=style&index=0&id=3713fa61&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__